import React from 'react'
import PropTypes from 'prop-types'

import Price from 'components/text/Price/Price'
import OldAndNewPrices from 'components/text/OldAndNewPrices/OldAndNewPrices'


const ConditionalPrice = ({ className, price, discountedPrice, isCents }) => {
  if (discountedPrice && discountedPrice < price) {
    return (
      <OldAndNewPrices
        className={className}
        oldPrice={price}
        newPrice={discountedPrice}
        isCents={isCents}
      />
    )
  }

  return (
    <Price
      className={className}
      isCents={isCents}
    >
      {price}
    </Price>
  )
}

ConditionalPrice.propTypes = {
  price: PropTypes.number,
  discountedPrice: PropTypes.number,
  isCents: PropTypes.bool,
}

ConditionalPrice.defaultProps = {
  isCents: false,
}


export default ConditionalPrice
